import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Mobile",
  "use": "Mobile-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"Mobile\"><path d=\"M22.4 2H9.6C8.2 2 7.1 3.1 7.1 4.5v22.9c0 1.4 1.1 2.5 2.5 2.5h12.7c1.4 0 2.5-1.1 2.5-2.5V4.5c.1-1.4-1-2.5-2.4-2.5zm0 22.9H9.6V7.1h12.7v17.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol